export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md',
  loading = false,
  disabled = false,
  block = false,
  type = 'button',
  className = '',
  ...props 
}) {
  const variants = {
    primary: 'bg-rdi-blue text-white hover:bg-rdi-blue-light',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
    success: 'bg-rdi-green text-white hover:bg-green-600',
    danger: 'bg-rdi-red text-white hover:bg-red-600',
    outline: 'border-2 border-rdi-blue text-rdi-blue hover:bg-rdi-blue hover:text-white',
    ghost: 'text-gray-600 hover:bg-gray-100',
  }

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg',
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`
        ${variants[variant]}
        ${sizes[size]}
        ${block ? 'w-full' : ''}
        rounded-md font-medium transition-all duration-200 
        disabled:opacity-50 disabled:cursor-not-allowed
        active:scale-95
        flex items-center justify-center gap-2
        ${className}
      `}
      {...props}
    >
      {loading && (
        <span className="spinner w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      )}
      {children}
    </button>
  )
}
